/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import {
  Grid,
  TextField,
  Typography,
  FormControl,
  useMediaQuery,
  InputAdornment,
  FormHelperText,
  Button,
  Box,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import IconExpandInformation from "../../icons/IconExpandInformation";
import IconHideInfomation from "../../icons/IconHideInfomation";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import AutoCompleteInput from "../../../../Components/FormComponents/AutoCompleteInput";
import {
  getCarInfoCompany,
  getCarInfoModel,
  getCarManufacturedYears,
  getCarVersion,
  getListOrigin,
  getKmTraveledSuggestion,
  getCarOptionByVersion,
} from "../../../MainBody/api";
import { SelectOption, CarCompanyInfo, CarInfoModel } from "./type";
import { listHideCarBrand, CAR } from "./constant";
import { ChildRef } from "Components/MainBodyV2/CarType/type";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { minDate, maxDate } from "Common/common";
import useStyles from "./useStyles";
import { ResultCarPrice } from "Components/Result/types";
import { OTHER } from "./constant";

export interface CarFormRef {
  resetVehicleInspectionOcrId: () => void;
}

interface ICarForm {
  isLoadCarPrice: boolean;
  onValueChange: (value: string) => void;
  dataFormImage: any;
  setDataFromImage: any;
  setCarPriceValue: React.Dispatch<React.SetStateAction<ResultCarPrice>>;
}

const CarForm = forwardRef<ChildRef, ICarForm>(
  (
    {
      isLoadCarPrice,
      onValueChange,
      dataFormImage,
      setDataFromImage,
      setCarPriceValue,
    },
    ref,
  ) => {
    const { state, pathname } = useLocation();

    const navigate = useNavigate();
    const isTabletOrMobile = useMediaQuery("(max-width: 1050px)");
    const { t } = useTranslation();
    const theme = useTheme();
    const classes = useStyles();
    const [listCarCompany, setListCarCompany] = useState<SelectOption[]>([]);
    const [listCarInfoModel, setListCarInfoModel] = useState<SelectOption[]>(
      [],
    );
    const [listOrigin, setListOrigin] = useState<SelectOption[]>([]);
    const [listVersion, setListVersion] = useState<SelectOption[]>([]);
    const [listManufactured, setListManufactured] = useState<SelectOption[]>(
      [],
    );
    const [listOption, setListOption] = useState<SelectOption[]>([]);

    const [selectedModel, setSelectedModel] = useState<SelectOption>({
      id: "",
      label: "",
    });
    const [selectedOption, setSelectedOption] = useState<SelectOption>({
      id: "",
      label: "",
    });
    const [selectedVersion, setSelectedVersion] = useState<SelectOption>({
      id: "",
      label: "",
    });
    const [selectedOrigin, setSelectedOrigin] = useState<SelectOption>({
      id: "",
      label: "",
    });
    const [selectedCarCompany, setSelectedCarCompany] = useState<SelectOption>({
      id: "",
      label: "",
    });

    const [startDate, setStartDate] = useState<Dayjs | null>(null);

    const [onRoad, setOnRoad] = useState<string>("");
    const [selectedManufactured, setSelectedManufactured] =
      useState<SelectOption>({ id: "", label: "" });
    const [openCarModel, setOpenCarModel] = useState(false);
    const [openCarManufactured, setOpenCarManufactured] = useState(false);
    const [openCarVersion, setOpenCarVersion] = useState(false);
    const [openCarOption, setOpenCarOption] = useState(false);
    const [openCarOrigin, setOpenCarOrigin] = useState(false);
    const [expandMore, setExpandMore] = useState(false);
    const [open, setOpen] = useState<boolean>(false);

    const resetSelect = () => {
      setCarPriceValue((prev: any) => ({
        ...prev,
        carValue: 0,
        maxPrice: null,
        minPrice: null,
        minListedPrice: null,
        maxListedPrice: null,
        hanoiOnRoadPrice: null,
        generalOnRoadPrice: null,
        hcmOnRoadPrice: null,
      }));
      setSelectedCarCompany({ id: "", label: "" });
      setSelectedModel({ id: "", label: "" });
      setSelectedVersion({ id: "", label: "", key: "" });
      setSelectedManufactured({ id: "", label: "" });
      setDataFromImage(null);
      setStartDate(null);
    };

    useImperativeHandle(ref, () => ({
      triggerAction: handleTrigger,
    }));

    const handleTrigger = () => {
      resetSelect();
    };

    useEffect(() => {
      (async () => {
        const getCarInfo: CarCompanyInfo[] = await getCarInfoCompany(1000);
        let newListOption: SelectOption[] = [];
        if (getCarInfo && getCarInfo.length > 0) {
          getCarInfo.forEach((company) => {
            const option: SelectOption = {
              id: company.carCompanyId,
              label: company.vehicleBrandName,
            };
            newListOption.push(option);
          });
          listHideCarBrand.forEach((element) => {
            newListOption = newListOption.filter(
              (option) => option.id !== element,
            );
          });
          setListCarCompany(newListOption);
        }

        if (dataFormImage && dataFormImage?.predictedCarCompany) {
          const nameOfCarCompany = dataFormImage?.predictedCarCompany;
          const findCarCompany = newListOption.find(
            (company) => company?.label === nameOfCarCompany,
          );

          if (findCarCompany) setSelectedCarCompany(findCarCompany);
        }
      })();
    }, [listHideCarBrand, dataFormImage]);

    useEffect(() => {
      if (selectedCarCompany && selectedCarCompany.id !== "") {
        setSelectedModel({ id: "", label: "" });
        setSelectedVersion({ id: "", label: "" });
        setSelectedManufactured({ id: "", label: "" });
        setSelectedOption({ id: "", label: "" });
        setSelectedOrigin({ id: "", label: "" });
        setListCarInfoModel([]);

        (async () => {
          const listCarInfoModel: CarInfoModel[] = await getCarInfoModel(
            selectedCarCompany?.id ?? "",
            100,
          );
          const newListOption: SelectOption[] = [];

          if (listCarInfoModel && listCarInfoModel.length > 0) {
            listCarInfoModel.forEach((model) => {
              const option: SelectOption = {
                id: model.carModelId,
                label: model.carModelName,
              };
              newListOption.push(option);
            });
            setListCarInfoModel(newListOption);
            if (state && state?.model) setSelectedModel(state?.model);
          }
          if (dataFormImage && dataFormImage?.predictedCarModel) {
            const nameOfCarModel = dataFormImage?.predictedCarModel;
            const findCarModel = newListOption.find(
              (model) => model?.label === nameOfCarModel,
            );
            if (findCarModel) setSelectedModel(findCarModel);
          }
        })();
      } else {
        setSelectedModel({ id: "", label: "" });
        setSelectedOption({ id: "", label: "" });
        setSelectedOrigin({ id: "", label: "" });
        setListOption([]);
      }
    }, [selectedCarCompany, dataFormImage]);

    useEffect(() => {
      if (selectedModel && selectedModel.id !== "") {
        setSelectedVersion({ id: "", label: "" });
        setSelectedManufactured({ id: "", label: "" });
        setSelectedOrigin({ id: "", label: "" });
        setListManufactured([]);

        (async () => {
          const listManufacturedYears: number[] = await getCarManufacturedYears(
            selectedCarCompany.id,
            selectedModel.id,
          );
          const newListManufactured: SelectOption[] = [];
          if (listManufacturedYears && listManufacturedYears.length > 0) {
            listManufacturedYears.forEach((manufactured) => {
              const option: SelectOption = {
                id: manufactured.toString(),
                label: manufactured.toString(),
              };
              newListManufactured.push(option);
            });
            setListManufactured(newListManufactured);
            if (state && state?.manufactureyear)
              setSelectedManufactured(state?.manufactureyear);
          }
          if (dataFormImage && dataFormImage.predictedYear) {
            const nameOfManufactured = dataFormImage.predictedYear;
            const findManufactured = newListManufactured.find(
              (manufactured) =>
                manufactured?.label === nameOfManufactured.toString(),
            );
            if (findManufactured) setSelectedManufactured(findManufactured);
          }
        })();
      } else {
        setSelectedManufactured({ id: "", label: "" });
        setSelectedOrigin({ id: "", label: "" });
      }
    }, [selectedModel, selectedCarCompany, dataFormImage]);

    useEffect(() => {
      if (selectedManufactured && selectedManufactured.id !== "") {
        setSelectedVersion({ id: "", label: "" });
        setSelectedOrigin({ id: "", label: "" });
        setListVersion([]);
        setStartDate(null);

        (async () => {
          const listVersion = await getCarVersion(
            selectedCarCompany?.id,
            selectedModel.id,
            selectedManufactured.id,
          );
          const newListOption: SelectOption[] = [];
          if (listVersion && listVersion.length > 0) {
            listVersion.forEach((version: any) => {
              const option: SelectOption = {
                id: version.carVersionId,
                label: version.carVersionName,
                key: version.carVersionKey,
                fuel: version.carFuelName,
              };
              newListOption.push(option);
            });
            setListVersion(newListOption);
            if (state && state?.version) setSelectedVersion(state?.version);
            if (state && state?.date) setStartDate(dayjs(state?.date));
          }
          if (dataFormImage && dataFormImage?.predictedCarVersion) {
            const nameOfCarVersion = dataFormImage?.predictedCarVersion;
            const findCarVersion = newListOption.find(
              (version) => version?.label === nameOfCarVersion,
            );
            if (findCarVersion) setSelectedVersion(findCarVersion);
          }
        })();
        (async () => {
          const kmTraveld = await getKmTraveledSuggestion(
            selectedManufactured.id,
          );
          setOnRoad(kmTraveld.kmTraveledSuggest);
        })();
      } else {
        setSelectedVersion({ id: "", label: "" });
        setSelectedOrigin({ id: "", label: "" });
        setStartDate(null);
      }
    }, [
      selectedManufactured,
      selectedModel,
      selectedCarCompany,
      dataFormImage,
    ]);

    useEffect(() => {
      if (!state && !isLoadCarPrice)
        setCarPriceValue((prev: any) => ({
          ...prev,
          carValue: 0,
          maxPrice: null,
          minPrice: null,
          minListedPrice: null,
          maxListedPrice: null,
          hanoiOnRoadPrice: null,
          generalOnRoadPrice: null,
          hcmOnRoadPrice: null,
        }));
      if (selectedVersion && selectedVersion.id !== "") {
        setSelectedOrigin({ id: "", label: "" });
        setListOrigin([]);
        setListOption([]);

        (async () => {
          const listOrigin = await getListOrigin({
            carCompany: selectedCarCompany.label,
            carModel: selectedModel.label,
            carVersion: selectedVersion.label,
            year: parseInt(selectedManufactured.id, 10),
          });
          const newListOption: SelectOption[] = [];
          if (listOrigin && listOrigin.length > 0) {
            listOrigin.forEach((origin: any) => {
              const option: SelectOption = {
                id: origin.originId,
                label: origin.originName,
              };
              newListOption.push(option);
            });
            setListOrigin(newListOption);
            if (listOrigin.length >= 1) {
              setSelectedOrigin({
                id: listOrigin[0].originId,
                label: listOrigin[0].originName,
              });
            }
          }
        })();
        (async () => {
          const listCarOption = await getCarOptionByVersion(
            selectedCarCompany.label,
            selectedModel.label,
            selectedVersion.label,
            parseInt(selectedManufactured.id, 10),
          );
          const newListOption: SelectOption[] = [];
          if (listCarOption && listCarOption.length > 0) {
            listCarOption.forEach((item: any) => {
              const option: SelectOption = {
                id: item.optionId,
                label: item.optionName,
                key: item.optionKey,
              };
              newListOption.push(option);
            });
            setListOption(newListOption);
            if (listCarOption.length >= 1 && !state)
              setSelectedOption({
                id: listCarOption[0].optionId,
                label: listCarOption[0].optionName,
                key: listCarOption[0].optionKey,
              });
            if (state && state?.optionKey) setSelectedOption(state?.optionKey);
          } else {
            setListOption([]);
          }
          if (state)
            navigate(pathname, {
              replace: true,
              state: null,
            });
        })();
      } else {
        setListOrigin([]);
        setListOption([]);
        setSelectedOrigin({ id: "", label: "" });
        setSelectedOption({ id: "", label: "", key: "" });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedVersion]);

    useEffect(() => {
      if (!state && !isLoadCarPrice)
        setCarPriceValue((prev: any) => ({
          ...prev,
          carValue: 0,
          maxPrice: null,
          minPrice: null,
          minListedPrice: null,
          maxListedPrice: null,
          hanoiOnRoadPrice: null,
          generalOnRoadPrice: null,
          hcmOnRoadPrice: null,
        }));
    }, [selectedOption, selectedOrigin, onRoad, startDate, state]);

    useEffect(() => {
      if (state && state?.type === CAR && state?.company) {
        setSelectedCarCompany(state.company);
      }
    }, []);

    useEffect(() => {
      onValueChange(
        JSON.stringify({
          company: selectedCarCompany,
          model: selectedModel,
          manufactureyear: selectedManufactured,
          version: selectedVersion,
          originId: selectedOrigin,
          kmTraveled: onRoad,
          optionKey: selectedOption,
          ...(startDate && { date: startDate.format("YYYY-MM-DD") }),
        }),
      );
    }, [
      selectedCarCompany,
      selectedModel,
      selectedVersion,
      selectedManufactured,
      selectedOption,
      selectedOrigin,
      onRoad,
      startDate,
    ]);

    const handleChangeOnRoad = (event: React.ChangeEvent<HTMLInputElement>) => {
      const road = parseFloat(event.target.value);
      if (road < 0) {
        setOnRoad("0");
      } else if (road > 999999) {
        setOnRoad("999999");
      } else {
        setOnRoad(event.target.value);
      }
    };

    const isValidate =
      selectedCarCompany?.id !== "" &&
      selectedModel?.id !== "" &&
      selectedVersion?.id !== "" &&
      selectedManufactured?.id !== "";

    return (
      <>
        {isTabletOrMobile && (
          <Grid item xs={12} sm={12} md={12}>
            <Button
              variant="outlined"
              endIcon={!open ? <ExpandMoreIcon /> : <ExpandLessIcon />}
              sx={{
                color: theme.palette.mode === "dark" ? "white" : "black",
                border: "1px solid #E5E7EB",
                borderRadius: "8px",
              }}
              onClick={() => setOpen(!open)}
            >
              Tra cứu
            </Button>
          </Grid>
        )}
        {(open || !isTabletOrMobile) && (
          <>
            <Grid item xs={12} sm={5.6} md={12}>
              <AutoCompleteInput
                label={t("form.selection.brand.title")}
                listOption={listCarCompany}
                onChange={setSelectedCarCompany}
                value={selectedCarCompany}
                placeholder={t("form.selection.brand.placeholder")}
                onClose={() => {
                  setOpenCarModel(true);
                }}
                onOpen={() => {
                  setOpenCarModel(false);
                  setOpenCarVersion(false);
                }}
                hidden
              />
            </Grid>

            <Grid item xs={12} sm={5.6} md={12}>
              <AutoCompleteInput
                label={t("form.selection.model.title")}
                listOption={listCarInfoModel}
                onChange={setSelectedModel}
                value={selectedModel}
                disabled={selectedCarCompany?.id === ""}
                disabledReset={selectedCarCompany?.id === OTHER}
                placeholder={t("form.selection.model.placeholder")}
                open={selectedCarCompany?.id !== "" && openCarModel}
                onClose={() => {
                  setOpenCarModel(false);
                  setOpenCarManufactured(true);
                }}
                onOpen={() => {
                  setOpenCarModel(!openCarModel);
                  setOpenCarManufactured(false);
                  setOpenCarVersion(false);
                }}
                hidden
              />
            </Grid>

            <Grid item xs={12} sm={5.6} md={12}>
              <AutoCompleteInput
                label={t("form.selection.manufacture-year.title")}
                listOption={listManufactured}
                onChange={setSelectedManufactured}
                value={selectedManufactured}
                disabled={selectedModel?.id === ""}
                disabledReset={selectedModel?.id === OTHER}
                placeholder={t("form.selection.manufacture-year.placeholder")}
                open={selectedModel?.id !== "" && openCarManufactured}
                onClose={() => {
                  setOpenCarManufactured(false);
                  setOpenCarVersion(true);
                }}
                onOpen={() => {
                  setOpenCarManufactured(!openCarManufactured);
                  setOpenCarVersion(false);
                }}
                hidden
              />
            </Grid>

            <Grid item xs={12} sm={5.6} md={12}>
              <AutoCompleteInput
                label={t("form.selection.version.title")}
                listOption={listVersion}
                onChange={setSelectedVersion}
                value={selectedVersion}
                disabled={selectedManufactured?.id === ""}
                disabledReset={
                  selectedManufactured?.id.includes(OTHER) ?? false
                }
                placeholder={t("form.selection.version.placeholder")}
                open={selectedManufactured?.id !== "" && openCarVersion}
                onClose={() => {
                  setOpenCarVersion(false);
                }}
                onOpen={() => {
                  setOpenCarVersion(!openCarVersion);
                }}
                hidden
              />
            </Grid>
            <Grid item md={12} xs={12} sx={{ pt: 2 }}>
              <Box display="flex" flexDirection="column" gap={1}>
                <Typography variant="body2">Tra cứu giá lịch sử</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={startDate}
                    onChange={(newValue) => setStartDate(newValue)}
                    minDate={
                      selectedManufactured.id ===
                        new Date().getFullYear().toString() ||
                      selectedManufactured.id ===
                        (new Date().getFullYear() - 1).toString()
                        ? dayjs(`01/01/${selectedManufactured.id}`)
                        : dayjs(minDate())
                    }
                    maxDate={dayjs(maxDate())}
                    slotProps={{
                      field: { clearable: true },
                      textField: { size: "small" },
                    }}
                    format="DD/MM/YYYY"
                    views={["year", "month", "day"]}
                    disabled={!selectedManufactured.id}
                  />
                </LocalizationProvider>
                <Typography variant="caption" sx={{ color: "gray" }}>
                  Chọn thời gian trong quá khứ để xem lại giá thị trường thời
                  điểm đó.
                </Typography>
              </Box>
            </Grid>
            {listOption.length > 0 && (
              <Grid item xs={12} sm={5.6} md={12}>
                <AutoCompleteInput
                  label="Option"
                  listOption={listOption}
                  onChange={setSelectedOption}
                  value={selectedOption ?? { id: "", label: "", key: "" }}
                  placeholder="Select an option"
                  open={openCarOption}
                  onClose={() => {
                    setOpenCarOption(false);
                  }}
                  onOpen={() => {
                    setOpenCarOption(true);
                  }}
                  hidden
                />
              </Grid>
            )}
            <Grid item xs={12} sm={12} md={12}>
              <Button
                sx={{
                  textTransform: "unset",
                  border: "none",
                  color: "#4E65FF",
                  ":hover": {
                    border: "none",
                    backgroundColor: "transparent",
                  },
                }}
                onClick={() => setExpandMore(!expandMore)}
                variant="outlined"
                endIcon={
                  !expandMore ? (
                    <IconExpandInformation />
                  ) : (
                    <IconHideInfomation />
                  )
                }
              >
                Thông tin bổ sung{" "}
              </Button>
            </Grid>
            {expandMore && (
              <>
                {listOrigin.length > 0 && (
                  <Grid item xs={12} sm={5.6} md={12}>
                    <AutoCompleteInput
                      label="Xuất xứ"
                      listOption={listOrigin}
                      onChange={setSelectedOrigin}
                      value={selectedOrigin ?? { id: "", label: "" }}
                      placeholder="Xuất xứ"
                      open={openCarOrigin}
                      onClose={() => {
                        setOpenCarOrigin(false);
                      }}
                      onOpen={() => {
                        setOpenCarOrigin(true);
                      }}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={5.6} md={12}>
                  <FormControl variant="standard" sx={{ minWidth: "100%" }}>
                    <Typography
                      sx={{
                        fontFamily: "San Francisco Text",
                        fontWeight: 400,
                        fontSize: "14px",
                        padding: "5px 0px",
                        color:
                          theme.palette.mode === "dark" ? "white" : "black",
                      }}
                    >
                      Số km đã đi
                    </Typography>
                    <TextField
                      value={onRoad}
                      placeholder="Số km đã đi"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">Km</InputAdornment>
                        ),
                      }}
                      size="small"
                      onChange={handleChangeOnRoad}
                      type="number"
                    />
                    {selectedManufactured && selectedManufactured.id !== "" && (
                      <FormHelperText>
                        Đây là gợi ý số km đã đi trung bình theo tuổi xe của bạn
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              </>
            )}
            <Button
              style={{
                background: `${isValidate ? "#5768FF" : "#f0f0f0"}`,
                color: `${isValidate ? "#ffffff" : "#bdbdbd"}`,
              }}
              className={classes.valueButton}
              disabled={!isValidate}
              type="submit"
            >
              Tra cứu
            </Button>
          </>
        )}
      </>
    );
  },
);

export default CarForm;
